import { supabase } from './client';
import { error as logError } from '../../utils/logger';

/**
 * Het scholenregister.
 *
 * WAAROM DIT GEEN VRIJE TEKST MEER IS
 * ------------------------------------
 * Een leerkracht typte zijn school zelf in. Dat gaf twee problemen die elkaar
 * versterken:
 *
 *   1. "OBS De Regenboog" en "de regenboog" zijn voor ons twee scholen. Er zat
 *      een fuzzy suggestie op om dat te dempen, maar dempen is geen oplossing —
 *      de eerste die het anders typt, maakt een tweede school.
 *   2. Belangrijker: de naam was tegelijk het gegeven waaróp een beheerder
 *      verifieert. Iemand die zelf mag opschrijven waar hij werkt, levert de
 *      beheerder geen controleerbaar feit maar een bewering. Goedkeuren ziet er
 *      dan uit als een controle zonder er een te zijn, en dat is erger dan geen
 *      verificatie: het schept vertrouwen dat nergens op rust.
 *
 * Daarom keert de volgorde om. Wij (beheer) nemen een school op nadat de
 * verwerkersovereenkomst rond is; een leerkracht KIEST daaruit. Een school die
 * er niet bij staat is geen invulveld maar een AANVRAAG.
 *
 * STAND VAN ZAKEN
 * ---------------
 * De tabel `public.schools` bestaat nog niet (ontwerp: docs/specs/
 * SCHOOL_REGISTRY.md). Deze functie geeft dan een lege lijst terug, en de
 * registratie valt netjes terug op de aanvraagroute — de leerkracht kan altijd
 * verder, hij kan alleen niets zelf aan het register toevoegen. Dat is de
 * juiste faalstand: liever geen keuze dan een zelfgemaakte.
 */
export interface RegistrySchool {
  id: string;
  name: string;
  city: string | null;
}

/** Ontbrekende tabel. Geen storing, maar "het register bestaat nog niet". */
const UNDEFINED_TABLE = '42P01';
export async function fetchVerifiedSchools(): Promise<RegistrySchool[]> {
  const {
    data,
    error
  } = await supabase.from('schools').select('id, name, city').eq('status', 'verified').order('name');
  if (error) {
    // Alleen de ontbrekende tabel is verwacht. Elke andere fout is een echte
    // storing en moet in de log zichtbaar blijven, niet stilletjes als "geen
    // scholen" worden gepresenteerd — dan lijkt een storing op een leeg
    // register en stuurt de UI iedereen onnodig naar de aanvraagroute.
    if ((error as {
      code?: string;
    }).code !== UNDEFINED_TABLE) {
      logError('[Schools] Scholenregister ophalen mislukt', error);
    }
    return [];
  }
  return (data ?? []).map(row => ({
    id: row.id as string,
    name: row.name as string,
    city: (row.city as string | null) ?? null
  }));
}
